import React from "react";
import { withFormik } from "formik";
import PropTypes from "prop-types";
import BasicInput from "./fields/BasicInput";
import "../../styles/vendor/react-checkbox-tree.css";
import { Link } from "react-router-dom";

class InnerForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    //this._handleRoleChange = this._handleRoleChange.bind(this);
  }

  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    venue: PropTypes.object,
    setValues: PropTypes.func,
    isCreating: PropTypes.bool,
    setFieldValue: PropTypes.func
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { venue } = nextProps;
    const currentProps = this.props;

    if (currentProps.venue !== venue) {
      currentProps.setValues({
        name: venue.name,
        id: venue.id
      });
    }

    if (currentProps.isCreating && !nextProps.isCreating) {
      currentProps.resetForm();
    }
  }

  render() {
    const props = this.props;

    return (
      <form className="m-login__form m-form" onSubmit={props.handleSubmit}>
        <div className="m-portlet__body">
          <input type="hidden" name="id" />
          <BasicInput {...props} name="name" type="text" label="Name" />
        </div>
        <div className="m-portlet__foot">
          <div className="row align-items-center">
            <div className="col-lg-12 m--align-right">
              {!props.venue && [
                <button
                  key="1"
                  className={
                    "btn m-btn btn-primary" +
                    (props.isSubmitting
                      ? " m-btn--custom m-loader m-loader--light m-loader--left"
                      : "")
                  }
                  disabled={props.isSubmitting}
                  onClick={() => this.props.setFieldValue("redirect", true)}
                >
                  Create & Add Zones
                </button>,

                <button
                  key="3"
                  className={
                    "m--margin-left-10 btn m-btn btn-secondary" +
                    (props.isSubmitting
                      ? " m-btn--custom m-loader m-loader--light m-loader--left"
                      : "")
                  }
                  disabled={props.isSubmitting}
                >
                  {props.venue ? "Update" : "Create"}
                </button>
              ]}

              {props.venue && [
                <button
                  key="1"
                  className={
                    "btn m-btn btn-primary" +
                    (props.isSubmitting
                      ? " m-btn--custom m-loader m-loader--light m-loader--left"
                      : "")
                  }
                  disabled={props.isSubmitting}
                >
                  Update
                </button>,
                <span key="2" className="m--margin-left-10">
                  or{" "}
                  <Link to="/admin/venues" className="m-link m--font-bold">
                    Cancel
                  </Link>
                </span>
              ]}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const VenueForm = withFormik({
  mapPropsToValues: props => {
    let values = {
      name: "",
      id: null,
      redirect: false
    };

    const { venue } = props;
    if (venue) {
      values.name = venue.name;
      values.id = venue.id;
    }

    return values;
  },
  validate: (values, props) => {
    let errors = {};

    if (!values.name || values.name === "") {
      errors.name = "required";
    }

    return errors;
  },

  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  }
})(InnerForm);

export default VenueForm;
